import React from 'react';

import {
  TableWrapper,
  MobileCreditRating,
  MobileCreditRatingTable,
  MobileCreditRatingRow,
  MobileCreditRatingHeader,
  MobileCreditRatingTextWrapper,
  MobileCreditRatingText,
  MobileCreditRatingSubText,
} from './styles';

import Table, { propTypes as tablePropTypes } from '../Table';

export const propTypes = {
  table: tablePropTypes,
  creditRating: tablePropTypes,
};

const renderRow = (header, value, index) => {
  const { text, subText } = value;

  const isBold = index === 0;

  return (
    <MobileCreditRatingRow>
      <MobileCreditRatingHeader bold={isBold}>
        {header.text}
      </MobileCreditRatingHeader>
      <MobileCreditRatingTextWrapper>
        <MobileCreditRatingText>{text}</MobileCreditRatingText>
        {subText && <MobileCreditRatingSubText>{subText}</MobileCreditRatingSubText>}
      </MobileCreditRatingTextWrapper>
    </MobileCreditRatingRow>
  );
};

const renderTable = (headers, values) => (
  <MobileCreditRatingTable>
    {headers.map((item, i) => renderRow(item, values[i], i))}
  </MobileCreditRatingTable>
);

const renderCreditRating = (table) => {
  const { headers, rows } = table;

  return (
    <div>
      {rows.map((item, i) => renderTable(headers, item))}
    </div>
  );
};

const CreditRating = ({
  table,
}) => (
  <div>
    <TableWrapper>
      <Table data={table} evenly />
    </TableWrapper>
    <MobileCreditRating>
      {renderCreditRating(table)}
    </MobileCreditRating>
  </div>
);

CreditRating.propTypes = {
  ...propTypes,
};

export default CreditRating;
